import React, { useEffect, useState, useCallback } from "react";
import { authController } from '@reedexpo/authorization-component-ui';
import { Routes } from '../../routes';

export const PostLogin = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Automatic restart (after first missing state) should KEEP the retry flag so the next visit shows the error.
  const automaticRestart = useCallback(() => {
    const target = `${window.location.origin}/`;
    const injected = (window as any).__replace;
    if (typeof injected === 'function') {
      injected(target);
    } else if (typeof window.location.replace === 'function') {
      window.location.replace(target);
    } else {
      window.location.href = target;
    }
  }, []);

  // Manual restart via user clicking the retry button should CLEAR the flag so flow can attempt fresh.
  const manualRetry = useCallback(() => {
    sessionStorage.removeItem('auth_missing_state_retry');
    automaticRestart();
  }, [automaticRestart]);

  useEffect(() => {
    const config = { ...(window as any)['authSettings'] };

    // Normalise redirectUri to current origin + auth callback path to avoid origin/path mismatches
    const expectedRedirect = `${window.location.origin}${Routes.authpcke}`;
    if (config && config.redirectUri && config.redirectUri !== expectedRedirect) {
      config.redirectUri = expectedRedirect; // mutate local copy only
    }

    authController.initialize(config);

    try {
      authController.handleCallback(window.location.search.substring(1));
    } catch (e: any) {
      const message = e?.message || '';
      const isMissingState = /No matching state found in storage/i.test(message);
      if (isMissingState) {
        // Prevent infinite loops – only retry once automatically
        const alreadyRetried = sessionStorage.getItem('auth_missing_state_retry');
        if (!alreadyRetried) {
          sessionStorage.setItem('auth_missing_state_retry', '1');
          automaticRestart();
          return;
        }
        setErrorMessage('Sign-in session expired or invalid. Please retry sign-in.');
        return;
      }
      // Unexpected error – surface generic message but don't crash
      setErrorMessage('Authentication failed. Please retry.');
    }
  }, [])

  if (errorMessage) {
    return (
      <div style={{ padding: 24 }} data-testid="post-login-error">
        <p>{errorMessage}</p>
  <button onClick={manualRetry} data-testid="retry-sign-in-btn" style={{ cursor: 'pointer' }}>
          Retry sign-in
        </button>
      </div>
    );
  }

  return <div/>;
};
